import API from "../../../../config/api";

export default {
    data() {
        return {
            cnt:0
        }
    },
    methods:{
        // 保存脚本
        saveSript(flag) {
            for (let i = 0; i < this.variableIdList.length; i++) {
                console.log("查询中",this.variableIdList[i],this.updateVariableId)
                if (this.variableIdList[i] === this.updateVariableId) {
                    this.updateVariable = this.variableList[i];
                    break;
                }
            }
            this.content = this.pre_done(this.content);
            let header = {
                "Content-Type": "application/x-www-form-urlencoded"
            }

            let data = {
                companyId: this.companyId,
                id: this.script["id"],
                scriptSource: encodeURIComponent(this.content),
                description : this.script["description"],
            }
            // console.log("保存的数据为:",data)
            this.$axiosRequest({
                url: API.updateScript,
                method: 'POST',
                data: data,
                header: header,
                success: res => {
                    //console.log("res,",res.data)
                    if (res.data === 0) {
                        this.$message({
                            message: '已存在该标题脚本！',
                            type: 'warning',
                        })
                    } else if (res.data === -2) {
                        this.$message({
                            message: '参数出错！',
                            type: 'warning',
                        })
                    } else if (res.data === -1) {
                        //console.log("系统错误")
                        this.$message({
                            message: '系统错误！',
                            type: 'warning',
                        })
                    } else if (flag !== 1) {
                        this.$message({
                            message: '保存成功！',
                            type: 'success',
                        })
                    }
                }
            });
        },
        // 把内容的多个空格转化为单个,把[]里的空格回车都删除
        pre_done(content) {
            let res = "";
            for (let i = 0; i < content.length; i++) {
                if (i > 0 && (content[i] === ' ' || content[i] === '\n') && content[i] === content[i - 1]) continue;
                res += content[i];
            }
            res = res.replace("[ ", "[").replace(" ]", ']');
            res = res.replace("[\n", "[").replace("\n]", ']');
            return res;
        },
        checkVariable(content, varablies) {    // 判断变量是否合法并生成TriggerVariableIds
            if (!content.startsWith('[')) return "找不到符号[";
            if (!content.endsWith(']')) return "找不到符号]";
            content = content.substr(1, content.length - 2);
            if (varablies.includes(content)) {
                for (let i = 0; i < this.variableIdList.length; i++) {
                    if (varablies[i] === content) {
                        if (this.variableIdList[i] === this.updateVariableId){
                            this.cnt++;
                            if (this.cnt === 1) break
                        }
                        this.TriggerVariableIds += "," + this.variableIdList[i];
                        break;
                    }
                }
                return "未发现问题";
            } else return "不存在相应的变量：" + content;
        },
        // 获得公司的所有变量
        getVariableList() {
            this.variableList=[];
            this.variableIdList=[];
            let header = {
                "Content-Type": "application/x-www-form-urlencoded"
            }

            let data = {
                companyId: this.companyId,
            }

            this.$axiosRequest({
                url: API.getVariableList,
                method: 'POST',
                data: data,
                header: header,
                success: res => {
                    let variableList = res.data["variableList"]
                    // console.log("variableList：",variableList, variableList.length)
                    for (let i = 0; i < variableList.length; i++) {
                        // console.log(variableList[i]['variableName'])
                        this.variableList.push(variableList[i]['variableName'].toLowerCase());
                        this.variableIdList.push(variableList[i]['id']);
                        console.log('333',this.variableIdList)
                    }
                }

            });
        },
        checkExpression(content, varablies) {    // 判断表达式是否合法
            let ops = ["+", "-", "*", "/", "%", "&&", "||", "=", "<", "<=", ">", ">=", "!=", "&", "|", "^"];
            let functionName = ["if", "abs", "sin", "cos", "tan", "pow"];
            let num = 0;     // 括号数量
            let val = [], op = [];   // 运算数值列表和运算符列表
            let msg = "";
            let tmp1 = 0, flag = 0, tmp2 = "";   // tmp1是当前数值,flag标记前方有-和~，tmp2是运算符
            for (let i = 0; i < content.length; i++) {
                if (content[i] === '!') {     // !单独处理
                    let j = i + 1;
                    while (j < content.length && (content[j] === ' ' || content[j] === '(' || content[j] === ')')) j++;
                    if (j === content.length || ops.includes(content[j])) return "多余的运算符：!";
                    continue;
                }
                if (content[i] === ' ') {   // 碰到空格,把当前的数值整理入列表
                    if (flag !== 0) {
                        if (op.length > 0) {
                            let tmpOp = op[op.length - 1];
                            if (tmp1 === 0 && flag === 1 && (tmpOp === "/" || tmpOp === "%")) {   // 当前是除或取模,但是数值是0
                                return "出现除0或取模0错误";
                            }
                        }
                        if (flag !== 1 && tmp1 === 0) {
                            if (flag === -2) return "不合法的运算符:~";
                            else return "不合法的运算符:-";
                        }
                        if (val.length > op.length) return tmp1 * flag + "前缺少运算符";   // 值已经大于运算符数量了,还加,说明运算符缺失了
                        val.push(tmp1 * flag);
                        tmp1 = 0;
                        flag = 0;
                    }
                    if (tmp2 !== "") {
                        if (!(ops.includes(tmp2))) {
                            return "不合法的运算符:" + tmp2;
                        }
                        op.push(tmp2);
                        if (op.length > val.length) return "多余的运算符：" + tmp2;
                        tmp2 = "";
                    }
                    continue;
                }
                if (content[i] === '(') num++;
                else if (content[i] === ')') num--;
                else if (content[i] === '[') {     // 是变量
                    if (flag !== 0) {
                        if (op.length > 0) {
                            let tmpOp = op[op.length - 1];
                            if (tmp1 === 0 && flag === 1 && (tmpOp === "/" || tmpOp === "%")) {   // 当前是除或取模,但是数值是0
                                return "出现除0或取模0错误";
                            }
                        }
                        if (flag !== 1 && tmp1 === 0) {
                            if (flag === -2) return "不合法的运算符:~";
                            else return "不合法的运算符:-";
                        }
                        if (val.length > op.length) return tmp1 * flag + "前缺少运算符";   // 值已经大于运算符数量了,还加,说明运算符缺失了
                        val.push(tmp1 * flag);
                        tmp1 = 0;
                        flag = 0;
                    }
                    if (tmp2 !== "") {
                        if (!(ops.includes(tmp2))) {
                            return "不合法的运算符:" + tmp2;
                        }
                        op.push(tmp2);
                        if (op.length > val.length) return "多余的运算符：" + tmp2;
                        tmp2 = "";
                    }
                    let j = i;
                    let tmp = "";
                    while (j < content.length && content[j] !== ']') {
                        tmp += content[j];
                        j++;
                    }
                    if (j < content.length) tmp += content[j];
                    let msg = this.checkVariable(tmp, varablies);
                    if (msg !== "未发现问题") return msg;
                    i = j;
                    if (val.length > op.length) return tmp + "前缺少运算符";
                    val.push(1);   // 变量也是一个运算值
                } else if (content[i] >= 'a' && content[i] <= 'z') {   // 是函数
                    if (flag !== 0) {
                        if (op.length > 0) {
                            let tmpOp = op[op.length - 1];
                            if (tmp1 === 0 && flag === 1 && (tmpOp === "/" || tmpOp === "%")) {   // 当前是除或取模,但是数值是0
                                return "出现除0或取模0错误";
                            }
                        }
                        if (flag !== 1 && tmp1 === 0) {
                            if (flag === -2) return "不合法的运算符:~";
                            else return "不合法的运算符:-";
                        }
                        if (val.length > op.length) return tmp1 * flag + "前缺少运算符";   // 值已经大于运算符数量了,还加,说明运算符缺失了
                        val.push(tmp1 * flag);
                        tmp1 = 0;
                        flag = 0;
                    }
                    if (tmp2 !== "") {
                        if (!(ops.includes(tmp2))) {
                            return "不合法的运算符:" + tmp2;
                        }
                        op.push(tmp2);
                        if (op.length > val.length) return "多余的运算符：" + tmp2;
                        tmp2 = "";
                    }
                    let j = i;
                    let name = "";
                    while (j < content.length && content[j] !== '(') {  // 取到第一个左括号
                        name += content[j];
                        j++;
                    }
                    if (!functionName.includes(name)) return "函数" + name + "不存在";   // tmp现在是函数名
                    if (j >= content.length) return "函数" + name + "缺失(";
                    if (val.length > op.length) return "函数" + name + "前缺少运算符";
                    val.push(1);    // 函数也是一个运算值
                    j++;
                    let num = 1;
                    let tmp = "";
                    while (j < content.length && num !== 0) {   // 函数的括号内容
                        if (content[j] === '(') num++;
                        else if (content[j] === ')') num--;
                        if (num !== 0) tmp += content[j];
                        j++;
                    }
                    if (j === content.length && num !== 0) return "函数" + name + "缺失)"
                    let cnt = 0;   // 参数个数
                    let tmpx = "";  // 参数根据,分隔,分别获取并且判断合法性
                    for (let j = 0; j < tmp.length; j++) {
                        if (tmp[j] === ',') {
                            if (num !== 0) {
                                tmpx += tmp[j];
                                continue;
                            }
                            cnt++;
                            msg = this.checkExpression(tmpx, varablies);   // 判断是否是一个合法的表达式
                            if (msg !== "未发现问题") return msg;
                            tmpx = "";
                        } else {
                            tmpx += tmp[j];
                            if (tmp[j] === '(') num++;
                            else if (tmp[j] === ')') num--;
                        }
                    }
                    if (tmpx !== "") {
                        cnt++;
                        msg = this.checkExpression(tmpx, varablies);
                        if (msg !== "未发现问题") return msg;
                        tmpx = "";
                    } else {
                        return "参数内容缺失";
                    }
                    if (name === "if") {    // if需要3个参数,其他的只需要1个
                        if (cnt !== 3) return "函数" + name + "的参数个数不正确";
                    } else if (name === "pow") {
                        if (cnt !== 2) return "函数" + name + "的参数个数不正确";
                    } else {
                        if (cnt !== 1) return "函数" + name + "的参数个数不正确";
                    }
                    i = j - 1;
                } else {
                    if ((content[i] >= '0' && content[i] <= '9') || ((tmp2 !== "" || op.length === 0) && content[i] === '-' && (flag === 0 || flag === -2)) ||
                        (flag === 1 && content[i] === '.') || ((flag === 0 || flag === -1) && content[i] === '~')) {
                        // 是数字，可能带负号,但是要保证之前没出现过运算符(出现在首位)或当前已经有运算符了(比如+ -5)并且之前未出现数字,也可能带小数点,必须保证小数点前面有数字
                        // 可能有~运算符修饰,~出现时,必须保证之前未出现过数字,但可以前面是-
                        if (tmp2 !== "") {
                            if (!(ops.includes(tmp2))) {
                                return "不合法的运算符:" + tmp2;
                            }
                            op.push(tmp2);
                            if (op.length > val.length) return "多余的运算符：" + tmp2;
                            tmp2 = "";
                        }
                        if (content[i] === '-') flag = -1;
                        else if (content[i] === '~') flag = -2;
                        else {
                            flag = 1;
                            tmp1 = tmp1 * 10 + (content[i] - '0');
                        }
                    } else {
                        if (flag !== 0) {
                            if (op.length > 0) {
                                let tmpOp = op[op.length - 1];
                                if (tmp1 === 0 && flag === 1 && (tmpOp === "/" || tmpOp === "%")) {   // 当前是除或取模,但是数值是0
                                    return "出现除0或取模0错误";
                                }
                            }
                            if (flag !== 1 && tmp1 === 0) {
                                if (flag === -2) return "不合法的运算符:~";
                                else return "不合法的运算符:-";
                            }
                            if (val.length > op.length) return tmp1 * flag + "前缺少运算符";   // 值已经大于运算符数量了,还加,说明运算符缺失了
                            val.push(tmp1 * flag);
                            tmp1 = 0;
                            flag = 0;
                        }
                        tmp2 += content[i];
                    }
                }
            }
            if (flag !== 0) {
                if (op.length > 0) {
                    let tmpOp = op[op.length - 1];
                    if (tmp1 === 0 && flag === 1 && (tmpOp === "/" || tmpOp === "%")) {   // 当前是除或取模,但是数值是0
                        return "出现除0或取模0错误";
                    }
                }
                if (flag !== 1 && tmp1 === 0) {
                    if (flag === -2) return "不合法的运算符:~";
                    else return "不合法的运算符:-";
                }
                if (val.length > op.length) return tmp1 * flag + "前缺少运算符";   // 值已经大于运算符数量了,还加,说明运算符缺失了
                val.push(tmp1 * flag);
                tmp1 = 0;
                flag = 0;
            }
            if (tmp2 !== "") return "多余的运算符：" + tmp2;
            if (num !== 0) return "括号不匹配";
            if (val.length === 0) return "表达式" + content + "没有运算值";
            return "未发现问题";
        },
        check(content, varablies) {
            this.TriggerVariableIds = ""
            this.cnt = 0
            let msg = ""
            content = content.replace(/\n/g, " ").toLowerCase().trim();     // 处理回车,全部转小写,去除前后空格
            //console.log("content",content)
            let id = content.indexOf("=");
            if (id === -1) return "格式错误,不存在=号";
            let pre = content.substr(0, id).trim()     // 截取等号前面内容
            msg = this.checkVariable(pre, varablies)              // 检查变量是否存在和格式问题
            if (msg !== "未发现问题") return msg
            let variable = pre.substring(1, pre.length - 1)
            if (variable !== this.updateVariable) {
                return "要更新的变量不符合初始设定"
            }
            content = content.substr(id + 1, content.length - id - 1).trim();  // 截取等号后面内容
            let inj_str = "call|create|alter|select|insert|delete|update|truncate|declare";
            let inj_stra = inj_str.split("|");
            for (let i = 0; i < inj_stra.length; i++) {
                if (content.indexOf(inj_stra[i]) !== -1) {
                    return "脚本包含sql关键字";
                }
            }
            if (content.startsWith("case")) {    // 以case开头的
                if (!content.endsWith("end")) {  // end结尾
                    return "格式错误,缺少end"
                }
                content = content.substr(4, content.length - 4 - 3);   // 截取中间内容
                let tmp = content.split("when");     // 按when分隔
                let elseNum = 0;           // 记录else的数量，最多只能一个
                for (let i = 0; i < tmp.length; i++) {
                    tmp[i] = tmp[i].trim();
                    if (tmp[i].length === 0) continue;
                    let v = tmp[i].split("then");    // 按then分隔,这样就只剩下两个表达式了
                    if (v.length !== 2) {
                        if (v.length < 2) return "缺少关键字then";
                        else return "then出现多次";
                    }
                    v[0] = v[0].trim();
                    v[1] = v[1].trim();
                    msg = this.checkExpression(v[0], varablies);    // 检查表达式
                    if (msg !== "未发现问题") return msg;
                    if (v[1].indexOf("else") !== -1) {       // 后面这个表达式可能存在else
                        elseNum++;
                        let tmpx = v[1].split("else");
                        if (tmpx.length > 2) return "else 出现多次";
                        msg = this.checkExpression(tmpx[0], varablies);
                        if (msg !== "未发现问题") return msg;
                        msg = this.checkExpression(tmpx[1], varablies);
                        if (msg !== "未发现问题") return msg;
                    } else {
                        msg = this.checkExpression(v[1], varablies);
                        if (msg !== "未发现问题") return msg;
                    }
                }
                if (elseNum > 1) return "else 出现多次";
            } else {
                return this.checkExpression(content, varablies);    // 不是case开头直接检查表达式
            }
            return "未发现问题";
        },
    }
}